import React, { useState } from 'react';
import Menu from './Menu.js';
import SentRequests from './SentRequests.js';
import MensajesOP from './MensajesOP.js'; 
import './UserOffice.css';

const UserOffice = () => {
  const [activeSection, setActiveSection] = useState('requests');

  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  return (
    <div className="vp-container">
      <Menu />
      <div className="vp-main-content">
        <div className="user-office">
          <nav className="office-menu">
            <button
              className={activeSection === 'requests' ? 'active' : ''}
              onClick={() => handleSectionChange('requests')}
            >
              Solicitudes
            </button>
            <button
              className={activeSection === 'messages' ? 'active' : ''}
              onClick={() => handleSectionChange('messages')}
            >
               <i className={`fa-solid ${activeSection === "messages" ? "fa-envelope-open-text" : "fa-envelope"}`}></i>
            </button>
          </nav>

          <div className="office-content">
            {activeSection === 'requests' && <SentRequests />}
            {activeSection === 'messages' && <MensajesOP />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserOffice;
